const updateScrollBarWidthVariable = () => {
  document.documentElement.style.setProperty('--scroll-bar-width', `${window.innerWidth - document.documentElement.clientWidth}px`)
}
updateScrollBarWidthVariable()


const updateWindowInnerHeightVariable = () => {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
}
updateWindowInnerHeightVariable()

export {updateWindowInnerHeightVariable, updateScrollBarWidthVariable}
